/* tslint:disable */
export default {
  // Menu Left
  ALL: "All",
  MEN: "Men",
  WOMEN: "Women",
  YOUTH_AND_KIDS: "Youth/Kids",
  KIDS: "Youth/Kids",
  SENIORS: "Seniors",
  DISABLED: "Disabled",
  FAMILIES: "Families",
  LGBT: "LGBT+",
  PETS_ALLOWED: "Pets Allowed",
  ANYONE: "Anyone",
  // Authencation
  SERVICE_PROVIDER_LOGIN: "Service Provider Login",
  SERVICE_PROVIDER_SIGNUP: "Service Provider Signup",
  SIGN_UP_AS: "Sign up as",
  PROVIDER: "Provider",
  DISPLAY_NAME_SIGNUP: "Community Service/ Volunteer Name",
  REQUIRED_INPUT_CTA: "Please input {{value}}",
  WELCOME_SHELTER: "Welcome to Shelter App",
  WELCOME_BACK: "Welcome back.",
  WELCOME_BACK_WITH_USER: "Welcome {{value}}.",
  HOME: "Home",
  FORGOT_PASSWORD: "Forgot Password",
  RESET_PASSWORD: "Reset Password",
  OR_CREATE_AN_ACCOUNT: "Or create an account",
  SIGN_IN: "LOGIN",
  SIGN_UP: "SIGN UP",
  CANCEL: "Cancel",
  EMAIL: "Email",
  PASSWORD: "Password",
  LOGOUT: "Log out",
  LOGOUT_THIS_ACCOUNT: "Log out this account?",
  SIGN_IN_WITH: "Login with",
  BY_CLICKING: "By clicking Sign up, you agree to ",
  DONATION: "Donation",
  PRIVACY_POLICY: "Privacy Policy",
  ACCEPT_TERM_OF_USE_AND_PRIVACY_POLICY: "Accept Terms of Use & Privacy Policy",
  PLEASE_ACCEPT_TERMS: "Please accept Terms & Privacy to continue.",
  SIGNED_OUT_SUCCESSFULLY: "Signed out successfully",
  PASSWORD_MIN_LENGTH: "Password must be at least {{value}} characters long.",
  EMAIL_OR_PASSWORD_INVALID:
    "Please check your Email or Password and Try Again.",
  OLD_PASSWORD_INVALID: "Please check your current password and try again.",
  PASSWORD_NOT_MATCH: "New Password did not Match. Please check and try again.",
  EMAIL_MUST_BE_A_VALID_EMAIL: "Please input valid Email.",
  REQUEST_RESET_PASSWORD_SUCCESSFULLY:
    "Please check your Email to Reset Password",
  EMAIL_NOT_FOUND: "Email not found.",
  RESET_PASSWORD_SUCCESSFULLY: "Reset password successfully.",

  // Service
  END_DATE_SHOULD_BE_GREATER:
    "End date should be equal or greater than Start date",
  FLAG_AND_DONATE: "Contact and Donate",
  IS_SHOW_CONTACT: "Please contact this service for hours",
  IS_ALLOWED_PETS: "Allow pets in the property",
  IS_SHOW_FLAG: "Show Flag",
  IS_CONTACT: "Is Contact",
  IS_SHOW_DONATE: "Show Donate",
  OWNED_BY: "Owned By",
  PLEASE_SELECT_AT_LEAST_ONE_SERVICE: "Please select at least one Service.",
  PLEASE_SELECT_AT_LEAST_ONE_CATEGORY: "Please select at least one Category.",
  PLEASE_ENTER_SERVICE_TYPE: "Please enter Service Description",
  PLEASE_ADD_SCHEDULE: "Please add schedule",
  NO_CHANGES_MADE: "No changes made.",
  ADDED_SUCCESSFULLY_AND_YOU_WANT_TO_CREATE_NEW:
    "Service Added Successfully. Do you want to add another one?",
  UPDATE_SERVICE_SUCCESSFULLY: "Service Updated Successfully",
  COMMUNITY_SERVICE_NAME: "Community Service/ Volunteer name",
  ADDRESS: "Address",
  ADDRESS_1: "Address 1",
  ADDRESS_2: "Address 2",
  ADD_TO_SCHEDULE: "Add to schedule",
  HOLIDAYS_CLOSED_DAYS: "Holidays closed days",
  UPDATE_SERVICE: "Update Service",
  THIS_SERVICE_IS_NOT_APPROVED: "This Service is waiting for Approval",
  THIS_SERVICE_IS_APPROVED: "This Service is Approved and Visible to Users",
  NO_SERVICES_ADDED: "No Services Added",
  ADDED_BY: "Added By",
  PHONE: "Phone",
  WEBSITE: "Website",
  SERVICES: "Services",
  SERVICE_TYPE: "Service Type",
  CATEGORIES: "Categories",
  AGE_GROUP: "Age Group",
  SCHEDULE: "Schedule",
  CLOSED_DAYS: "Closed days",
  COMMENT: "Comment",
  EDIT_SERVICE: "Edit Service",
  DELETE_SERVICE: "Delete Service",
  ADDED_TO_FAVORITE: "Added to My Favorites",
  REMOVED_TO_FAVORITE: "Removed from My Favorites",
  NAME: "Name",
  SEARCH_SERVICE: "Search Service",
  NO_FAVORITES:
    "No Favorites added. You can add a service to favorites by clicking on star at the top right of the service detail page.",
  CATEGORY: "Category",
  CONTACT_SERVICE: "Contact Service",
  NO_SERVICES_CLIENT:
    "No results found matching your criteria in {{value}} tab. Please choose other Tabs at the bottom or Change your location or Choose different options in Side Menu.",
  NO_MANAGE_SERVICE:
    "No services added. Please click on Add Services in Side Menu� and then link to",
  NO_SHELTER: "No shelter services available to update bed information.",
  ACCEPT: "Accept ",
  NO_DATA_SERVICES: "No Services Found. ",
  DESC_LESS_THAN_VALUE: "Description in less than {{value}} characters.",
  CONNECT_WITH_US: "Connect with this Service?",
  LAST_UPDATE_ON: "Last Updated on",
  OPEN_24H: "Open 24/7",
  TODAY_AT: "Today at",
  TOMORROW: "Tomorrow",
  YESTERDAY: "Yesterday",
  LAST_WEEK: "last week",
  LOW_BARRIER: "Low Barrier",

  // Menu
  OPTIONS: "Options",
  OPEN_SERVICES: "Open Services",
  TOP_KUDOS: "Top Kudos",
  MAP_VIEW: "Map View",
  CRISIS_LINES: "Crisis Lines",
  MY_FAVORITES: "My Favorites",
  ABOUT_SHELTER: "About Shelter App",
  SHOW_TUTORIAL: "Show Tutorial",
  GIVE_FEEDBACK: "Give Feedback",
  TERMS_OF_USE: "Terms of Use",
  ADD_SERVICE: "Add Service",
  MANAGE_SERVICES: "Manage Services",
  MANAGE_FEEDBACK: "Manage Feedback",
  UPDATE_SHELTER: "Update Available Beds",
  MANAGE_PROFILE: "Manage Profile",
  MANAGE_APPROVALS: "Manage Approvals",
  MANAGE_PERMS: "Manage Perms",
  MANAGE_USERS: "Manage Users",
  MANAGE_VOLUNTEERS: "Manage Volunteers",
  MANAGE_ACCESS: "Manage Access",
  CHANGE_PASSWORD: "Change Password",
  ENTER_NEW_PASSWORD: "Enter new password",
  LOGIN_AND_SIGNUP: "Provider/Volunteer Login/SignUp",
  MANAGE_VALIDATE_SERVICES: "Manage Validate Services",

  // Change Password
  CONFIRM_PASSWORD: "Confirm Password",
  CURRENT_PASSWORD: "Current Password",
  NEW_PASSWORD: "New Password",

  // Update Profile
  UPDATE_PROFILE: "Update Profile",
  UPDATE_PROFILE_SUCCESSFULLY: "User Profile Updated Successfully",
  UPDATE_AVATAR_SUCCESSFULLY: "Avatar Updated Successfully",
  UPDATE_AVATAR_ERROR: "Failed to update avatar",

  // My Favorite
  SEARCH_FAVORITES: "Search Favorites",

  // CRISLINES
  SEARCH_LINES: "Search Crisis Lines",
  ADD_CRISIS_LINE: "Add Crisis Line",
  UPDATE_LINE: "Update Crisis Line",
  UPDATE_CRISIS_LINE: "Update Crisis Line",
  CRISIS_LINE_INFORMATION: "Crisis Line Information",
  CRISIS_LINE_NAME: "Crisis line name",
  UPDATE_LINE_SUCCESSFULLY: "CrisisLine Updated Successfully",
  CHAT_WEB_LINK: "Chat Web Link",
  AREA: "Area",
  HOURS: "Hours",
  DO_YOU_WANT_TO_DELETE_THIS: "Do you want to delete this {{value}}?",
  ADDED_SUCCESSFULLY_AND_YOU_WANT_TO_CREATE_NEW_CRISLINES:
    "Crisisline Added Successfully. Do you want to add another one?",

  // DBACK
  CONNECT_TO: "Connect to {{value}} ?",
  SENT_FEEDBACK_SUCCESSFULLY: "Feedback Sent Successfully",
  ARE_YOU_SURE_WANT_TO_ARCHIVE_THIS: "Are you sure want to archive this?",
  FEEDBACK: "Feedback",
  SEND_FEEDBACK: "Send Feedback",
  AVAILABLE_BEDS: "Available Beds",
  NO_FEEDBACKS:
    "You don�t have any new feedback. Please check Archive tab for past feedback.",
  SEARCH_FEEDBACK: "Search Feedback",
  APP_FEEDBACK: "App Feedback",
  SERVICE_FEEDBACK: "Service Feedback",
  ARCHIVE: "Archive",
  MY_FEEDBACKS: "My Feedbacks",
  VOLUNTEER_FEEDBACKS: "Volunteer Feedback",

  // LOCATION
  CHOOSE_CITY_ZIP_FOR_SERVICES: "Choose City/Zip for Services",
  CURRENT_LOCATION: "Current Location",
  SEARCH_CITY_NAME_OR_ZIP_CODE: "Search City Name or Zip Code",
  NO_MATCHING_RESULTS_FOUND:
    "No matching results found. Please enter a different location.",
  CAN_NOT_GET_LOCATION:
    "Can not curent location. Go to Setting -> Open Location",
  ADD_YOUR_LOCATION: "Add your location",

  // MANAGE APPROVALS
  SEARCH_APPROVALS: "Search Approvals",
  APPROVE_SELECTED: "Approve Selected",
  APPROVE_ALL: "Approve All",
  DELETE_SELECTED: "Delete Selected",
  TUTORIALS: "Shelter Tutorials",
  APPROVED_SUCCESSFULLY: "Approved successfully",

  // USER
  USER_PROFILE: "User Profile",
  VOLUNTEER_PROFILE: "Volunteer Profile",
  UPDATE_USER_SUCCESSFULLY: "User Profile Updated Successfully",

  // PERMS
  APPROVED_USER_AS_ADMIN_SUCCESSFULLY: "Added {{value}} as Admin.",
  REMOVED_USER_AS_ADMIN_SUCCESSFULLY: "Removed {{value}} as Admin.",

  // DATE
  SUNDAY: "Sunday",
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  PERMANENTLY_CLOSED: "Permanently closed",
  DATE_RANGE: "Date range",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  DAILY: "Daily",
  FIRST: "First",
  SECOND: "Second",
  THIRD: "Third",
  FOURTH: "Fourth",
  FIFTH: "Fifth",
  LAST: "Last",

  // SHOW TUTORIAL
  I_AGREE: "I Agree",

  NETWORK_REQUEST_FAILED:
    "Can not connect to server. Please check your network.",
  ROLE: "Role",
  TOTAL_SERVICE: "Total Service",
  MINIMUM_TOTAL_SERVICE: "Minimum total service was {{value}}",
  CREATED_AT: "Created At",
  LAST_LOGIN_METHOD: "Last login method",
  LAST_LOGIN_AT: "Last login at",
  LAST_UPDATED_AT: "Last updated at",
  USER_NEED_NOT_SIGNUP:
    "Users need not Signup. This is for Service Providers and Volunteers only.",
  START_DATE: "Start date",
  END_DATE: "End date",
  START_TIME: "Start time",
  END_TIME: "End time",
  ADD_THIS_HEADER: "Add this Service to Header",
  NEVER_EXPIRIES: "Never Expires",
  MANAGED_BY: "Managed By",
  AVAILABLE_BEDS_LESS_THAN:
    "Available beds should be less than or equal to Total Beds",
  CHECK_TIME_START: "End Time should be greater than Start time",
  PLEASE_TYPE_TOTAL_BEDS: "Please type Total Beds",
  TOTAL_BEDS: "TOTAL BEDS",
  PLEASE_ENTER_COUNTRY: "Please enter Country",
  ADDED_SUCCESSFULLY: "Service Added Successfully.",
  CRITICAL_SERVICES: "Critical Services",
  CONTACT_GROUP: "Contact Service",
  SCHEDULE_TYPE: "Schedule type",
  SELECT_DAY: "Select day",
  NO_BEDS: "Bed info not available on any existing shelter services.",
  NO_ECYEH: "No services available to update bed information.",
  REPORT_SERVICE_INFO:
    "Click here to Report Incorrect Info or\n  Claim this Service",
  CITY: "city",
  STATE: "state",
  ZIP: "zip",
  COUNTRY: "Country",
  SERVICE_DETAILS: "service details",
  CRITICAL_DESC: "One-Sentence Description",
  SOCIAL_MEDIA_LINKS: "Social Media Links",
  SERVICE: "Service",
  MINIMUM_TOTAL_BEDS: "Minimum total beds was {{value}}",
  MINIMUM_AVAILABLE_BEDS: "Minimum available beds was {{value}}",
  EXPIRY_DATE: "Expiry Date",
  EXPIRY_TIME: "Expiry Time",
  MANAGED_USERS: "Managed Users",
  HOMELESS_LIAISONS: "Homeless Liaisons",
  HOMELESS_LIAISON: "Homeless Liaison",
  REGIONAL_COORDINATORS: "Regional Coordinators",
  ABOUT_ECYEH: "About App",
  VOLUNTEER: "Volunteer",
  DONATE: "Donate",
  MANAGE_SUPPER: "Manage Super Users",
  SEARCH_USERS: "Search Users",
  CRISIS_LINE: "Crisis Line",
  SEARCH_LIAISONS: "Search Homeless Liaisons",
  EDIT_CRISIS_LINE: "Edit Crisis Line",
  CRISIS_LINE_DESC: "Crisis line description",
  ADD_LINE_SUCCESSFULLY: "Crisisline Added Successfully.",
  YOU_REACHED_LIMIT_SERVICE:
    "You reached the Max Limit for adding new services. Please check with App Admin at shelterappinfo@gmail.com to request access to add more services.",
  TEXT: "TEXT",
  LIAISON: "Liaison",
  LOCATION: "Location",
  COUNTY: "County",
  SELECT_COUNTY: "Select County",
  POSITION: "Position",
  DISTRICT: "DISTRICT",
  ADD_LIAISON: "Add Liaison",
  EDIT_LIAISON: "Edit Liaison",
  UPDATE_LIAISON: "Update Liaison",
  LIAISON_NAME: "Liaison name",
  LIAISON_TITLE: "Liaison title",
  LIAISON_INFORMATION: "Liaison Information",
  LIAISON_SUCCESSFULLY: "Liaison Updated Successfully",
  ADDED_SUCCESSFULLY_AND_YOU_WANT_TO_CREATE_NEW_LIAISON:
    "Liaison Added Successfully. Do you want to add another one?",
  ADD_REGIONS: "Add Region",
  EDIT_REGIONS: "Edit Region",
  UPDATE_REGION: "Update Region",
  UPDATE_REGION_SUCCESSFULLY: "Region Updated Successfully",
  ADD_REGION_SUCCESSFUL: "Region Added Successfully",
  SELECT_REGION: "Select Region",
  REGION: "Region",
  REGIONS: "Regions",
  COUNTIES: "Counties",
  SEARCH_COORDINATOR: "Search Coordinator",
  UPDATE_COORDINATOR: "Update Regional Coordinator",
  EDIT_COORDINATOR: "Edit Regional Coordinator",
  ADD_COORDINATOR: "Add Regional Coordinator",
  ADD_ADDRESS: "Add Address",
  MOBILE_PHONE: "Mobile phone",
  FAX_PHONE: "Fax phone",
  OFFICE_PHONE: "Office phone",
  EXTENSION: "Extension",
  COORDINATOR: "COORDINATOR",
  REGIONAL_COORDINATOR: "Regional Coordinator",
  REPORT_TITLE: "Report incorrect Info or Claim this Service?",
  SENT_REPORT_SUCCESSFULLY: "Report Sent Successfully",
  SUBJECT: "Subject",
  SEND: "SEND",
  SERVICE_PROVIDER: "Service Provider",
  YES: "Yes",
  NO: "No",
  CHATBOT_FAQ: "Chatbot FAQ�s",
  DESCRIPTION: "description",
  TITLE: "Title",
  MESSAGE: "Message",
  PLEASE_INPUT_AT_LEAST_ONE_COORDINATOR:
    "Please input at least one Coordinator.",
  ADD_LIAISON_SUCCESSFULLY: "Liaison Added Successfully",
  UPDATE_LIAISON_SUCCESSFULLY: "Liaison Updated Successfully",
  ADD_COORDINATOR_SUCCESSFULLY: "Coordinator Added Successfully",
  UPDATE_COORDINATOR_SUCCESSFULLY: "Coordinator Updated Successfully",
  ATTACHMENTS: "ATTACHMENTS",
  AVAILABLE_TOTAL_BEDS: "Available/Total Beds",
  USER: "User",
  DELETE_LIAISON_SUCCESSFUL: "This liaison was removed successful!",
  DELETE_REGION_SUCCESSFUL: "This region was removed successful!",
  DELETE_SERVICE_SUCCESSFUL: "This service was removed successful!",
  DELETE_COORDINATOR_SUCCESSFUL: "This coordinator was removed successful!",
  DELETE_USER_SUCCESSFUL: "This user was removed successful!",
  DELETE_LINE_SUCCESSFUL: "This crisis line was removed successful!",
  SKIP: "SKIP",
  WELCOME_ECYEH: "Finding Your Way in PA Intro",
  MILES: "Miles",
  CLOSED_TILL: "Closed till",
  CLOSED_UNTIL: "Closed until",
  OPEN_STILL: "Open till",
  CLOSED_TILL_NEXT: "Closed till next",
  SLIDE_1:
    "Home Screen of the App displays list of services with info like Bed Availablility for Shelters, Open or Closed Times, Distance from your Location, etc. Feel Free to give Kudos to services that you like using",
  SLIDE_2_1:
    "You can click on any service on the Home Screen to get detailed info including Bus Directions to that service from your Location. You can click on ",
  SLIDE_2_2:
    " at the top right of details screen to add that service to My Favorites.",
  SLIDE_3:
    "Tabs at the bottom of Home screen will help you navigate to resources like Food, Shelter, Health, Resources & Education. Each tab has Sub Tabs on top of them like Clothes, Hygiene, Tech, etc., to help narrow your search.",
  CLICK_ON: "Clicking on ",
  SLIDE_4:
    " at the top of the Home Screen will take you to Options Menu where you can filter services based on Category like Youth, LGBT, Women,.. Services that are Open Now, Map View, Crisis Lines, My Favorites, etc.",
  SLIDE_5:
    "You can click on Crisis Lines in Options Menu to reach out to National Hotlines for emotional support. You can also search for Crisis Lines or Services using ",
  SLIDE_6:
    " on Home screen for services will help you connect to the App Admin or Service Provider for that resource.",
  CLICKING: "Clicking ",
  SLIDE_7_1:
    "You can view services in List View or Map View and can even search for another City or Zip using ",
  SLIDE_7_2: " at the top of Home Screen.",
  SLIDE_8:
    " Home Screen for interacting with our AI Powered Chatbot to find services with ease",
  ACCEPT_TERMS: "ACCEPT TERMS",
  SLIDE_9: "By Clicking I agree, you agree to the Shelter App, Inc's ",
  FOOD: "Food",
  SHELTER: "Shelter",
  HEALTH: "Health",
  RESOURCES: "Resources",
  EDUCATION: "Education",
  WORK: "Work",
  EMPLOYMENT: "Employment",
  MEALS: "Meals",
  FOOD_PANTRY: "Food Pantry",
  EMERGENCY: "Emergency",
  TRANSITIONAL: "Transitional",
  MEDICAL: "Medical",
  COUNSELING: "Counseling",
  CLOTHES: "Clothes",
  HYGIENE: "Hygiene",
  TECH: "Tech",
  ASSISTANCE: "Assistance",
  PH_COMMUNITY_SERVICE_NAME: "Non-Profit Name",
  PH_LINE_NAME: "Ex: Domestic Violence Hotline",
  PH_TEXT_NUMBER: "Text number",
  PH_DISTRICT: "Ex: Allegheny Valley School District",
  PH_LIAISON_TITLE: "Ex: Supervisor",
  PH_EXT: "Ex: 12217",
  PH_EMAIL: "Ex: abc@gmail.com",
  PH_DISPLAY_NAME_PROFILE: "Ex: Hotel California",
  PH_DISPLAY_NAME_SIGNUP: "Non-Profit/Volunteer Name",
  PH_REGION_NAME: "Ex: Statewide",
  PH_COUNTIES: "Ex: Philadelphia",
  PH_ADDRESS_1: "Broadway & E Colfax Ave",
  PH_ADDRESS_2: "Civic Center Park",
  PH_CITY: "Denver",
  PH_COUNTRY: "Select Country",
  PH_SERVICE_DETAILS:
    "Ex: Food Pantry, Emergency Shelter, HIV Test, Clothes, GED Training...",
  PH_TOTAL_BED: "1 or more",
  PH_AVAILABLE_BEDS: "0 or more",
  PH_AGE_GROUP: "Ex: 18+, 17-21, 24 & under, All Ages, ...",
  PH_FULL_NAME: "Ex: Full Name",
  PH_COORDINATOR_NAME: "Ex: Center for Schools and Communities",
  LANGUAGE: "Language: Spanish",
  LANGUAGE_LABEL: "Language",
  // Time
  OPEN_TILL: "Open till",
  DUPLICATED_DAY: "Duplicated day",
  DUPLICATED_DAY_CLOSED: "Opening and holiday schedules cannot overlap.",
  USERNAME: "Username",
  PH_USERNAME: "Ex: John Doe",
  PH_LOCATION: "Ex: Philadelphia, PA",
  EDIT_AVATAR: "Edit Avatar",
  SAVE: "Save",

  // Validate Services
  VALIDATE_SERVICES: "Validate Services",
  NO_SERVICES_TO_VALIDATE: "No services to validate.",
  VALIDATE_SERVICE: "Validate Service",
  REPORT_ISSUE: "Report Issue",
  ISSUE: "ISSUE",
  REPORT_SERVICE_AS_DUPLICATE: "Report this service as a duplicate",
  REPORT_MISSING_OR_INCORRECT_INFO: "Report missing or incorrect information",
  MARK_AS_VALIDATED: "Update Service",
  VALIDATE_SERVICE_SUCCESSFULLY: "Service updated successfully",
  MARK_VALIDATED_ERROR: "Failed to update service.",
  SENT_FEEDBACK_REPORT_ISSUE_SUCCESSFULLY: "The issue report was sent successfully",
  LAST_VALIDATED: "Last validated",
  REJECT_SUCCESSFULLY: "Rejected successfully.",
  REJECT_ERROR: "Failed to reject draft.",
  APPROVE_SERVICE: "Approve Service",
  VALIDATED_DATA: "Validated Data",
  VALIDATED_BY: "Validated By",
  APPROVE_CHANGES: "Approve Changes",
  REJECT_CHANGES: "Reject Changes",
  CHANGED_DATA: "Changed Data",

  // My Work
  MY_WORK: "My Work",
  ACTIVITY: "Activity",
  BADGES: "Badges",
  STATISTICS: "Statistics",
  CERTIFICATES: "Certificates",
  THIS_FEATURE_IS_UNDER_DEVELOPMENT: "This feature is under development.",
  LOADING: "Loading...",
	NUMBER_OF_SERVICES_VALIDATED: "Number of services validated",
	NUMBER_OF_APPROVED_SERVICES_VALIDATED: "Number of validated services approved",
	NUMBER_OF_SERVICES_ADDED: "Number of services added",
	NUMBER_OF_BADGES_EARNED: "Number of badges earned",
  POINTS: "Points",
  ACHIEVED_ON: "Achieved on {{date}}",
  NOT_ACHIEVED: "Not achieved",
  NO_BADGES_YET: "No badges yet.",
  SHARE: "Share",
  DOWNLOAD_IMAGE: "Download",
  BADGE_IMAGE_DOWNLOADED: "Image downloaded",
  SHARE_OPTIONS_PROMPT: "Choose how to share your badge",
  SHARE_BADGE_MESSAGE:
    "I am happy to share that I have obtained a new badge: {{badgeName}}! #ShelterApp #Volunteer",
  COPIED_TO_CLIPBOARD: "Copied to Clipboard",
  TIME_VOLUNTEERED: "Time Volunteered",
  BADGE: "Badge",
  VALIDATED_SERVICES: "Validated Services",
  ADDED_SERVICES: "Added Services",
  POINTS_EARNED: "Points Earned",
  CURRENT_BADGE: "Current Badge",
  MY_CURRENT_RANK: "My current rank",
  NO_ACTIVITIES_YET: "No activities yet.",
  NO_ADDITIONAL_HISTORY: "No additional history to be shown.",
  CERTIFICATE_HOURS_AND_REQUIREMENT:
    "You have {{value}} of volunteer work. You need to complete at least 4 hours of service to receive the certificate.",
  NO_CERTIFICATES_AVAILABLE: "No certificates available.",
  SEARCH_NAME: "Search Name",

  // Leaderboard
  VOLUNTEER_LEADERBOARD: "Volunteer Leaderboard",
  TOTAL_VOLUNTEER_TIME: "Total volunteer time",
  ALL_TIME: "All Time",
  YEARLY: "Yearly",
  TOP_RANKED: "Top Ranked",
  MY_RANK: "My Rank",
  VIEW_AHEAD: "View Ahead",
  NO_MORE_DATA_AHEAD: "No more data ahead.",
  NO_LEADERBOARD_DATA: "No leaderboard data yet.",
  LEADERBOARD_MY_RANK_NOT_RANKED:
    "You don't have enough points to be ranked yet. Start Volunteering!",
  TAKE_PHOTO: "Take Photo",
  CAPTURE: "Capture",
  USE_THIS_PHOTO: "Use This Photo",
  RETAKE: "Retake",
  FROM: "from",
  EDIT_LOCATION: "Edit Location",
  SELECT_COUNTRY: "Select country",
  SELECT_STATE: "Select State or Province",
  SELECT_CITY: "Select city of state (optional)",
  FACEBOOK: "Facebook",
  TWITTER: "Twitter",
  INSTAGRAM: "Instagram",
  YOUTUBE: "YouTube",
  FILTER: "Filter",
  FILTER_VALIDATED: "Validated",
  FILTER_DUPLICATED: "Duplicated",
  FILTER_MISSING_INCORRECT: "Missing or Incorrect Info",
  FILTER_UNVALIDATED: "Unvalidated",
  SORT: "Sort",
  LEAST_RECENTLY_UPDATED_SERVICE: "Least Recently Updated Service",
  SORT_NEAREST: "Nearest to me",
  CLEAR_FILTER: "Clear filter",
  NO_SERVICES_BEFORE: "No services added. Please click on",
  NO_SERVICES_AFTER: "in Side Menu.",
  DELETE_SERVICE_CONFIRM: "Do you want to delete this service?",
  NO_VOLUNTEER_SERVICES: "No services",
  NO_VOLUNTEERS: "No volunteers",
  EDIT: "Edit",
  DELETE: "Delete",
  DELETE_USER_CONFIRM: "Do you want to delete this user?",
  IS_DISPLAY_ON_CERTIFICATE: "Display on certificate",
  TIME_0_MINUTES: "0 minutes",
  TIME_1_MINUTE: "1 minute",
  TIME_MINUTES: "{{value}} minutes",
  TIME_1_HOUR: "1 hour",
  TIME_HOURS: "{{value}} hours",
  PH_SEARCH_VOLUNTEERS: "Search by name, email",
  MANAGE_VOLUNTEERS_WORK: "Manage Volunteers Work",
  SELECT_VOLUNTEER: "Select Volunteer :",
  CONGRATULATIONS: "Congratulations!",
  CLOSE: "Close",
  VIEW: "View",
  MANAGE_APP_UPDATE: "Manage App Update",
  MIN_VERSION: "Min version",
  FORCE_UPDATE: "Force update",
  IOS_LINK: "iOS link",
  ANDROID_LINK: "Android link",
  UPDATE: "Update",
  APP_VERSIONING_UPDATED_SUCCESSFULLY: "App versioning updated successfully.",
  MIN_VERSION_INVALID_FORMAT: "Version must be in x.x.x format (e.g. 2.8.8).",
  RECEIVED_AT: "Received at",
  ARCHIVED_AT: "Archived at",
};
